export const translations = {
  fr: {
    nav: {
      about: "À Propos",
      services: "Services",
      steps: "Processus",
      reserve: "Réserver",
    },
    hero: {
      eyebrow: "Conciergerie de Luxe",
      title: "L'art de l'exception,\nau bout d'une clé.",
      sub: "Excellence. Discrétion. Réactivité.",
      cta: "Découvrir",
      ctaSecondary: "Nous contacter",
    },
    trust: "EXCELLENCE · DISCRÉTION · RÉACTIVITÉ · SUR-MESURE · 24/7",
    about: {
      eyebrow: "À Propos",
      title: "Une conciergerie pensée\ncomme un privilège.",
      p1: "PRESTIGE KEY est née d'une conviction simple : votre temps est précieux et vos exigences méritent une réponse à la hauteur. Nous orchestrons pour vous des prestations sur-mesure, sans bruit et sans accroc.",
      p2: "Une équipe dédiée veille en permanence sur chaque détail pour que vous n'ayez qu'à profiter.",
      pillars: [
        { title: "Excellence", desc: "Adresses confidentielles, partenaires triés sur le volet, standards intransigeants." },
        { title: "Discrétion", desc: "Confidentialité absolue. Vos demandes restent vôtres, toujours." },
        { title: "Réactivité", desc: "Une réponse en quelques minutes, à toute heure, partout dans le monde." },
      ],
    },
    services: {
      eyebrow: "Services",
      title: "Trois clés. Une infinité de possibilités.",
      sub: "Sélection rigoureuse, exécution impeccable.",
      items: [
        {
          tag: "01",
          name: "Hôtels",
          desc: "Suites privées, palaces internationaux et adresses introuvables — réservés à votre nom.",
        },
        {
          tag: "02",
          name: "Voitures",
          desc: "Berlines, SUV et supercars avec chauffeur, livrés où vous le souhaitez.",
        },
        {
          tag: "03",
          name: "Vols",
          desc: "Business et First Class de -30 % à -70 % sur le prix des billets. Voyagez au sommet, payez moins.",
        },
      ],
      reserve: "Réserver",
    },
    steps: {
      eyebrow: "Processus",
      title: "Trois étapes,\nzéro friction.",
      sub: "Une approche épurée pour des résultats sans compromis.",
      items: [
        {
          n: "01",
          title: "Demande client",
          desc: "Partagez votre besoin par WhatsApp. Un concierge dédié prend connaissance de votre demande en peu de temps.",
        },
        {
          n: "02",
          title: "Organisation sur mesure",
          desc: "Nous négocions, sélectionnons et bâtissons une proposition entièrement à votre image.",
        },
        {
          n: "03",
          title: "Confirmation & exécution",
          desc: "Vous validez, nous exécutons. Chaque détail est suivi en temps réel jusqu'à votre entière satisfaction.",
        },
      ],
      cta: "Démarrer une demande",
    },
    contact: {
      eyebrow: "Contact",
      title: "À votre service,\nen toute discrétion.",
      sub: "Notre concierge répond 24h/24, 7j/7 sur WhatsApp.",
      cta: "Écrire sur WhatsApp",
    },
    footer: {
      tagline: "Conciergerie de luxe — Présent partout, à toute heure.",
      rights: "Tous droits réservés.",
      links: { about: "À Propos", services: "Services", steps: "Processus" },
    },
  },
  en: {
    nav: {
      about: "About",
      services: "Services",
      steps: "Process",
      reserve: "Book",
    },
    hero: {
      eyebrow: "Luxury Concierge",
      title: "The art of the exceptional,\nat the turn of a key.",
      sub: "Excellence. Discretion. Responsiveness.",
      cta: "Discover",
      ctaSecondary: "Contact us",
    },
    trust: "EXCELLENCE · DISCRETION · RESPONSIVENESS · BESPOKE · 24/7",
    about: {
      eyebrow: "About Us",
      title: "A concierge designed\nas a privilege.",
      p1: "PRESTIGE KEY was born from a simple belief: your time is precious and your standards deserve an answer that matches them. We orchestrate bespoke services for you — quietly, flawlessly.",
      p2: "A dedicated team watches over every detail, so you can simply enjoy.",
      pillars: [
        { title: "Excellence", desc: "Confidential addresses, hand-picked partners, uncompromising standards." },
        { title: "Discretion", desc: "Absolute confidentiality. Your requests stay yours, always." },
        { title: "Responsiveness", desc: "A reply in minutes, at any hour, anywhere in the world." },
      ],
    },
    services: {
      eyebrow: "Services",
      title: "Three keys. Infinite possibilities.",
      sub: "Rigorous curation, impeccable execution.",
      items: [
        {
          tag: "01",
          name: "Hotels",
          desc: "Private suites, international palaces and hidden addresses — reserved in your name.",
        },
        {
          tag: "02",
          name: "Cars",
          desc: "Sedans, SUVs and supercars with chauffeur, delivered wherever you wish.",
        },
        {
          tag: "03",
          name: "Flights",
          desc: "Business and First Class from -30% to -70% off ticket prices. Travel at the top, pay less.",
        },
      ],
      reserve: "Book",
    },
    steps: {
      eyebrow: "Process",
      title: "Three steps,\nzero friction.",
      sub: "A pared-down approach for uncompromising results.",
      items: [
        {
          n: "01",
          title: "Client request",
          desc: "Share your request on WhatsApp. A dedicated concierge takes ownership shortly after.",
        },
        {
          n: "02",
          title: "Tailor-made organisation",
          desc: "We negotiate, curate and craft a proposal entirely in your image.",
        },
        {
          n: "03",
          title: "Confirmation & execution",
          desc: "You approve, we execute. Every detail is tracked in real time until your full satisfaction.",
        },
      ],
      cta: "Start a request",
    },
    contact: {
      eyebrow: "Contact",
      title: "At your service,\ndiscreetly.",
      sub: "Our concierge replies 24/7 on WhatsApp.",
      cta: "Message on WhatsApp",
    },
    footer: {
      tagline: "Luxury concierge — Present everywhere, at any hour.",
      rights: "All rights reserved.",
      links: { about: "About", services: "Services", steps: "Process" },
    },
  },
};

export const WHATSAPP_NUMBER = "33695083102";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const INSTAGRAM_URL = "https://www.instagram.com/prestige_keyy?igsh=eTFiZGozd2Q4YjNk";
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_key-concierge/artifacts/w3bc3y1l_PRESTIGE-no-bg.png";

export const buildWhatsAppLink = (message) => {
  const encoded = encodeURIComponent(message);
  return `${WHATSAPP_URL}?text=${encoded}`;
};
